/* eslint-disable import/prefer-default-export */
import { put } from 'redux-saga/effects';
import UTIL from '../../util';
// import { dispatchServerAppLogs } from '..';
// import LogLevelEnum from '../../enums/logLevel';

export function* callAPIMain(payload, actionType, apiHandlerName: Function) {
  const startTime = new Date().getTime();
  try {
    console.info('sending request', actionType, new Date().getTime() - startTime, payload);
    const response = yield apiHandlerName(payload);
    console.info(
      actionType,
      'response time',
      new Date().getTime() - startTime,
      'response',
      response,
    );
    yield put({
      type: `${actionType}_SUCCESS`,
      payload: response.data,
    });
  } catch (error) {
    console.warn(`error ${actionType}`, error, error.response);
    const tempPayload = UTIL.errorHandling(error);
    yield put({
      type: `${actionType}_FAILURE`,
      payload: tempPayload,
    });
  }
}

export function* callAPILogin(payload, actionType, apiHandlerName: Function, hasLocation = true) {
  if (hasLocation) {
    try {
      // dispatchServerAppLogs(LogLevelEnum.INFO, 'Fetching location');
      const location = yield new Promise((resolve, reject) => {
        UTIL.getLocationUsingType(
          (latitude, longitude) => {
            resolve({ latitude, longitude });
          },
          error => reject(error),
        );
      });
      // dispatchServerAppLogs(LogLevelEnum.INFO, 'Fetched location');
      if (location) {
        const { latitude, longitude } = location;
        const requestBody = {
          ...payload,
          longitude,
          latitude,
          geoLocation: `${latitude},${longitude}`,
        };
        // dispatchServerAppLogs(LogLevelEnum.INFO, 'Calling Api');
        yield callAPIMain(requestBody, actionType, apiHandlerName);
      }
    } catch (error) {
      console.warn(`error ${actionType}`, error);
      const tempPayload = UTIL.errorHandling(error);
      yield put({
        type: `${actionType}_FAILURE`,
        payload: tempPayload,
      });
    }
  } else {
    yield callAPIMain(payload, actionType, apiHandlerName);
  }
}
